<script>
    import R, {LOADER} from "../lib/requests";
    import {ROUTE_TYPES} from "../lib/constants";
    import {formatDate} from "../lib/lib";
    import Notifier from "../stores/notifier";
    import PageHeader from "../components/PageHeader.svelte";
    import DateControl from "../components/controls/DateControl.svelte";
    import Breadcrumb from "../components/Breadcrumb.svelte";
    import AppIcon from "../components/icons/AppIcon.svelte";

    const pageHeaderControls = [
        {id: 'reload', name: '', icon: 'refresh'}
    ];
    const breadcrumb = [
        {id: 'reservations', name: 'Reservations', link: `/app/reservations`}
    ];

    let search = {
        date_from: null,
        date_to: null,
        department_id: null,
        status: 'report',
    };

    let reservations = null;
    // let report = null;
    let departments = [];

    const load = () => {
        const onSuccess = result => {
            if (result.departments) {
                departments = result.departments;
                if (departments.length > 0) {
                    search.department_id = departments[0].id;
                }
                return;
            }
            reservations = result.reservations;
            // makeReport(result.reservations);
        }

        const onFailure = err => {
        };

        if (departments.length == 0) {
            search.initialize = 1;
        } else {
            if (!search.date_from || !search.date_to) {
                Notifier.showError("Please select report dates");
                return;
            }

            if (!search.department_id) {
                Notifier.showError("Please select department for the report!");
                return;
            }

            search.initialize = 0;
        }

        R.handle(R.reservation.report, search, onSuccess, onFailure, (reservations == null ? LOADER.PAGE : LOADER.POPUP));
    }

    // const makeReport = data => {
    //     report = [];
    //     data.map(reservation => {
    //        reservation.routes.map(route => {
    //            let item = {
    //                date: formatDate(reservation.created_at, 'd/m/y'),
    //                fullname: reservation.fullname,
    //                amount: route.price,
    //                type: '',
    //                transfer_date: route.transfer_at ? formatDate(route.transfer_at, 'd/m/y') : '',
    //                transfer_time: route.transfer_at ? formatDate(route.transfer_at, 'H:i') : '',
    //            }
    //            report.push(item);
    //        });
    //     });
    // }

    // const copyTableToClipboard = async () => {
    //     const table = document.getElementById("reportTable");
    //     const rows = Array.from(table.querySelectorAll("tr"));
    //
    //     const text = rows
    //         .map(row => {
    //             const cells = Array.from(row.querySelectorAll("th, td"));
    //             return cells
    //                 .map(cell => cell.innerText.trim().replace(/\n/g, " "))
    //                 .join("\t");
    //         })
    //         .join("\n");
    //
    //     try {
    //         await navigator.clipboard.writeText(text);
    //         Notifier.showMessage("Data copied to clipboard");
    //     } catch (err) {
    //         Notifier.showError("Copy to clipboard failed!");
    //     }
    // }

    const copyTableToClipboard = async () => {
        const table = document.getElementById("reportTable");
        if (!table) {
            Notifier.showError("Table not found!");
            return;
        }

        const clone = table.cloneNode(true);

        // Αντιγραφή βασικών computed styles inline
        const originalNodes = [table, ...table.querySelectorAll("*")];
        const cloneNodes = [clone, ...clone.querySelectorAll("*")];

        originalNodes.forEach((node, index) => {
            const clonedNode = cloneNodes[index];
            if (!(clonedNode instanceof HTMLElement)) return;

            const style = window.getComputedStyle(node);

            const inlineStyles = [
                `font-family: ${style.fontFamily}`,
                `font-size: ${style.fontSize}`,
                `font-weight: ${style.fontWeight}`,
                `font-style: ${style.fontStyle}`,
                `text-align: ${style.textAlign}`,
                `vertical-align: ${style.verticalAlign}`,
                `color: ${style.color}`,
                `background-color: ${style.backgroundColor}`,
                `border-top: ${style.borderTop}`,
                `border-right: ${style.borderRight}`,
                `border-bottom: ${style.borderBottom}`,
                `border-left: ${style.borderLeft}`,
                `padding: ${style.padding}`,
                `white-space: ${style.whiteSpace}`,
            ];

            // Το Excel καταλαβαίνει καλύτερα explicit bold στα TH
            if (clonedNode.tagName === "TH") {
                inlineStyles.push("font-weight: bold");
            }

            clonedNode.setAttribute("style", inlineStyles.join("; "));
        });

        // Βεβαιώσου ότι το table έχει κάποια σημαντικά styles
        clone.style.borderCollapse = "collapse";

        // plain text fallback
        const plainText = Array.from(table.querySelectorAll("tr"))
            .map((row) => {
                const cells = Array.from(row.querySelectorAll("th, td"));
                return cells
                    .map((cell) => cell.innerText.trim().replace(/\n/g, " "))
                    .join("\t");
            })
            .join("\n");

        // Excel-friendly HTML
        const html = `
            <html xmlns:o="urn:schemas-microsoft-com:office:office"
                  xmlns:x="urn:schemas-microsoft-com:office:excel"
                  xmlns="http://www.w3.org/TR/REC-html40">
                <head>
                    <meta charset="UTF-8">
                    <!--[if gte mso 9]>
                    <xml>
                        <x:ExcelWorkbook>
                            <x:ExcelWorksheets>
                                <x:ExcelWorksheet>
                                    <x:Name>Report</x:Name>
                                    <x:WorksheetOptions>
                                        <x:DisplayGridlines/>
                                    </x:WorksheetOptions>
                                </x:ExcelWorksheet>
                            </x:ExcelWorksheets>
                        </x:ExcelWorkbook>
                    </xml>
                    <![endif]-->
                </head>
                <body>
                    ${clone.outerHTML}
                </body>
            </html>
        `;

        try {
            await navigator.clipboard.write([
                new ClipboardItem({
                    "text/plain": new Blob([plainText], {type: "text/plain"}),
                    "text/html": new Blob([html], {type: "text/html"}),
                }),
            ]);

            Notifier.showMessage("Data copied to clipboard");
        } catch (err) {
            console.error(err);
            Notifier.showError("Copy to clipboard failed!");
        }
    };

    load();
</script>

<Breadcrumb {breadcrumb}/>
<PageHeader title="Reservations Report" controls={pageHeaderControls} on:reload={load}/>

<div class="panel-simple p-2 pb-0 mb-5">
    <div class="row">
        <div class="col-xl-2 col-6 mb-2">
            <DateControl placeholder="from" bind:value={search.date_from}/>
        </div>
        <div class="col-xl-2 col-6 mb-2">
            <DateControl placeholder="to" bind:value={search.date_to} openRight/>
        </div>
        <div class="col-xl-2 mb-2">
            <select class="form-select" bind:value={search.department_id}>
                <option value={null}>department</option>
                {#each departments as item}
                    <option value="{item.id}">{item.name}</option>
                {/each}
            </select>
        </div>
        <div class="col-xl-4 mb-2">
        </div>
        <div class="col-xl-2 col-6">
            <button class="btn btn-outline d-block w-100" on:click={load}>REPORT</button>
        </div>
    </div>
</div>

{#if reservations}
    {#if reservations.length == 0}
        <div class="alert alert-info">
            No reservations found.
        </div>
    {:else}
        <div class="legend mb-3">
            Report data
            <button class="btn btn-default btn-sm" title="copy to clipboard" on:click={copyTableToClipboard}>
                <AppIcon icon="copy" size="16"/>
            </button>
        </div>
        <div class="table-wrapper">
            <table class="report-table" id="reportTable">
                <thead>
                <tr>
                    <td colspan="7">
                        <strong>From:</strong> {formatDate(search.date_from, 'd/m/y')}
                        &nbsp;&nbsp;&nbsp;&nbsp;
                        <strong>To:</strong> {formatDate(search.date_to, 'd/m/y')}
                    </td>
                </tr>
                <tr>
                    <th width="50">A/A</th>
                    <th width="110">Payment Date</th>
                    <th>Name</th>
                    <th>Amount (Credit Card)</th>
                    <th>Type</th>
                    <th width="110">Transfer Date</th>
                    <th width="80">Time</th>
                </tr>
                </thead>
                <tbody>
                {#each reservations as reservation, index}
                    <tr>
                        <td>{index + 1}</td>
                        <td>{formatDate(reservation.created_at, 'd/m/y')}</td>
                        <td>{reservation.fullname}</td>
                        <td>
                            {#if reservation.route_price}
                                {reservation.route_price}€
                            {/if}
                        </td>
                        <td>
                            {ROUTE_TYPES[reservation.route_type]}
                        </td>
                        <td>
                            {#if reservation.transfer_at}
                                {formatDate(reservation.transfer_at, 'd/m/y')}
                            {/if}
                        </td>
                        <td>
                            {#if reservation.transfer_at}
                                {formatDate(reservation.transfer_at, 'H:i')}
                            {/if}
                        </td>
                    </tr>
                {/each}
                </tbody>
            </table>
        </div>
    {/if}
{/if}

<style>
    .table-wrapper {
        overflow-x: auto;
        max-width: 100%;
    }

    .report-table {
        border-collapse: collapse;
        width: 100%;
        min-width: 1400px;
    }

    .report-table th, .report-table td {
        text-align: left;
        vertical-align: top;
        white-space: nowrap;
        border: 1px solid #ddd;
        background: #fff;
        padding: 8px;
    }

    .report-table th {
        font-weight: 600;
    }
</style>